export interface ActivityFilters {
  q?: string;
  category?: string;
  city?: string;
  min_price?: string;
  max_price?: string;
  sort?: string;
  page?: string;
  page_size?: string;
  exact_category?: string;
  /** `bookable_first`: bookable rows only, or every row when none are bookable. */
  mode?: "bookable" | "explore" | "all" | "bookable_first";
  segment?: string;
  /**
   * Hub slug — bookable category OR explore segment of the same name, for the
   * slugs that are both (`spas`, `stays`). Implies `mode=all` server-side.
   */
  hub?: string;
  lang?: string;
  currency?: string;
  /** "true" adds `priceHistogram` to the response (the Filters sheet's price chart). */
  histogram?: string;
  /** One collection tag (restaurants hub chips): keep only venues carrying it. */
  tag?: string;
  /** One cuisine (restaurants hub cuisine chips). Combines with `tag`. */
  cuisine?: string;
  /** "true" adds `tagCounts` to the response, for the chip counts. */
  tag_counts?: string;
  /**
   * "1" on a submitted search (the explore page), so an empty result is
   * counted for the admin Supply and demand page. Never on the header's
   * as-you-type suggestions.
   */
  log?: string;
  /** "1": only venues open right now (Morocco time). Category pages with opening hours. */
  open_now?: string;
  /** "1": bookable venues with an evening seating still ahead today. */
  tonight?: string;
  /** YYYY-MM-DD: the booking bar's day. */
  date?: string;
  /** HH:mm: the booking bar's time. */
  time?: string;
}

export const activityKeys = {
  all: ["activities"] as const,
  list: (filters: ActivityFilters) => [...activityKeys.all, "list", filters] as const,
  detail: (slug: string, lang?: string) =>
    [...activityKeys.all, "detail", slug, lang ?? "en"] as const,
  availability: (slug: string, date: string) =>
    [...activityKeys.all, "availability", slug, date] as const,
  exploreLinks: (city: string, lang?: string) =>
    [...activityKeys.all, "explore-links", city, lang ?? "en"] as const,
  categories: (city?: string) => [...activityKeys.all, "categories", city ?? null] as const,
  cities: () => [...activityKeys.all, "cities"] as const,
};

export const bookingKeys = {
  all: ["bookings"] as const,
  detail: (id: string, lang?: string) =>
    [...bookingKeys.all, "detail", id, lang ?? "en"] as const,
};
